import { Field } from 'react-final-form';
import { CheckBoxField } from '@unite-us/ui';
import formUtils from '../utils/formUtils';

function CustomCheckboxField ({ name, label, id, options, required, ...rest }) {
  return (
    <Field
      name={name}
      validate={formUtils.required(rest.language)}
    >
      {(params, index) => (
        <>
          <CheckBoxField
            label={label}
            id={id}
            // options={formUtils.formatOptions(options)}
            {...params}
            required={required}
          />
        </>
      )}
    </Field>
  );
};

export default CustomCheckboxField;
